/*
 * @Author: Lemon C
 * @Date: 2024-05-30 14:34:24
 * @LastEditTime: 2024-05-30 15:14:30
 */
import { defineStore } from 'pinia';

export const useSearchStore = defineStore('search', {
    state: () => ({
        searches: JSON.parse(localStorage.getItem('LS_searches')) || []
    }),
    actions: {
        addSearch(keyword) {
            const existingSearch = this.searches.find(search => search.keyword === keyword);
            if (existingSearch) {
                existingSearch.count++;
            } else {
                this.searches.push({ keyword, count: 1 });
            }
            this.saveToLocalStorage();
        },
        getSortedSearches() {
            return [...this.searches].sort((a, b) => b.count - a.count);
        },
        saveToLocalStorage() {
            localStorage.setItem('LS_searches', JSON.stringify(this.searches));
        },
        clearSearches() {
            this.searches = [];
            localStorage.removeItem('LS_searches');
        }
    }
});
